import { render, staticRenderFns } from "./TradeOffComponent.vue?vue&type=template&id=a622bac2&scoped=true"
import script from "./TradeOffComponent.vue?vue&type=script&lang=js"
export * from "./TradeOffComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a622bac2",
  null
  
)

export default component.exports